import type { DocumentNode } from 'graphql';
import { buildASTSchema } from 'graphql/utilities';

import schema from './schema';

// eslint-disable-next-line @trello/no-module-logic
export const astSchema = buildASTSchema(schema as DocumentNode, {
  assumeValidSDL: true,
});
